import type { MetricRecordData } from "@/types/metrics/contracts"

// Permanent identity shared with backend src/libs/metric_types/automatic_expected_behavior.py.
const AUTOMATIC_EXPECTED_BEHAVIOR_METRIC_ID = "AQsDMYycQSmveWMYWzoEz3"

interface ExpectedBehaviorCompositeMetricCandidate {
  id?: string | null
  metric_manager?: string | null
  metric_metadata?: MetricRecordData["metric_metadata"] | null
}

export function isAutomaticExpectedBehaviorMetric(
  metric: ExpectedBehaviorCompositeMetricCandidate | null | undefined,
): boolean {
  return (
    metric?.id === AUTOMATIC_EXPECTED_BEHAVIOR_METRIC_ID ||
    metric?.metric_metadata?.automatic_expected_behavior === true
  )
}

export function isExpectedBehaviorCompositeMetric(
  metric: ExpectedBehaviorCompositeMetricCandidate,
): boolean {
  return (
    metric.metric_manager === "manager_composite_evaluation" &&
    (metric.metric_metadata?.criteria_source ?? "test_case") === "test_case" &&
    (metric.metric_metadata?.criteria_path ?? "expected_behaviors") ===
      "expected_behaviors"
  )
}

export function isAutomaticExpectedBehaviorEnabled(): boolean {
  return (
    process.env.NEXT_PUBLIC_VERCEL_ENV === "preview" ||
    process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
  )
}

export function isEnabledAutomaticExpectedBehaviorMetric(
  metric: ExpectedBehaviorCompositeMetricCandidate | null | undefined,
): boolean {
  return (
    isAutomaticExpectedBehaviorEnabled() &&
    isAutomaticExpectedBehaviorMetric(metric)
  )
}
